module.exports = __webpack_public_path__ + "media/images/landing/bg/case-nestle/youtube-01787fd4460079c75c3897fa8953819b.png";